import React, { Component } from 'react';
import * as Sentry from "@sentry/browser";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { parse } from '../../util/urlHelpers';
import {
  Page,
  UserNav,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { ProfileSettingsForm } from '../../forms';
import { TopbarContainer } from '../../containers';

import { updateProfile } from './ProfileSettingsPage.duck';

import css from './ProfileSettingsPage.css';

export class ProfileSettingsPageComponent extends Component {
  render() {
    const {
      currentUser,
      image,
      onUpdateProfile,
      scrollingDisabled,
      updateInProgress,
      updateProfileError,
      uploadImageError,
      uploadInProgress,
      intl,
    } = this.props;

    const handleSubmit = values => {
      const { consents } = currentUser.attributes;
      const { firstName, lastName, terms, ...rest } = values;

      const updatedConsents = Object.keys(rest).map(c => {
        if (rest[c] === consents[c]) return undefined;
        return c
      }).filter(c => c)

      const updatedConsentsObj = updatedConsents.reduce((a, b) => {
        return { ...a, [b]: rest[b] }
      }, {});

      const profile = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        terms,
        consents: { ...updatedConsentsObj }
      };
      const uploadedImage = this.props.image;

      // Update profileImage only if file system has been accessed
      const updatedValues =
        uploadedImage && uploadedImage.imageId && uploadedImage.file
          ? { ...profile, profileImageId: uploadedImage.imageId }
          : profile;

      onUpdateProfile(updatedValues).then(() => redirectAfterSaving());
    };

    const redirectAfterSaving = () => {
      const { lId, page, cartId } = parse(this.props.location.search);

      if (lId) {
        this.props.history.push(`/l/${lId}`);
      }
      if (cartId) {
        this.props.history.push(`/${cartId}`);
      }
      if (page) {
        this.props.history.push(`/`);
      }
    }

    const user = ensureCurrentUser(currentUser);
    const { firstName, lastName, terms, consents = {} } = user.attributes;
    const profileImageId = user.profileImage ? user.profileImage.id : null;
    const profileImage = image || { imageId: profileImageId };

    const profileSettingsForm = user.id ? (
      <ProfileSettingsForm
        className={css.form}
        currentUser={currentUser}
        initialValues={{
          firstName,
          lastName,
          // marketingConsent: consents.email,
          terms,
          ...consents
        }}
        profileImage={profileImage}
        uploadInProgress={uploadInProgress}
        updateInProgress={updateInProgress}
        uploadImageError={uploadImageError}
        updateProfileError={updateProfileError}
        onSubmit={handleSubmit}
      />
    ) : null;

    const title = intl.formatMessage({ id: 'ProfileSettingsPage.title' });

    return (
      <Page className={css.root} title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer currentPage="ProfileSettingsPage" />
            <UserNav selectedPageName="ProfileSettingsPage" />
          </LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div className={css.content}>
              <div className={css.headingContainer}>
                <h1 className={css.heading}>
                  <FormattedMessage id="ProfileSettingsPage.heading" />
                </h1>
              </div>
              {profileSettingsForm}
              {
                currentUser?.attributes?.isAdmin &&
                <div>
                  Admin section Sentry error test
                  <SentryTestButtons />
                </div>
              }
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ProfileSettingsPageComponent.defaultProps = {
  currentUser: null,
  uploadImageError: null,
  updateProfileError: null,
  image: null,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    image,
    uploadImageError,
    uploadInProgress,
    updateInProgress,
    updateProfileError,
  } = state.ProfileSettingsPage;
  return {
    currentUser,
    image,
    scrollingDisabled: isScrollingDisabled(state),
    updateInProgress,
    updateProfileError,
    uploadImageError,
    uploadInProgress,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const ProfileSettingsPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(ProfileSettingsPageComponent);

ProfileSettingsPage.loadData = () => {
  // Since verify email happens in separate tab, current user's data might be updated
  return fetchCurrentUser({ include: ['image'], 'fields.user': ['firstName', 'terms', 'consents', 'lastName', 'email', 'hasProvider', 'abbreviatedName', 'displayName', 'language', 'isAdmin'] });
};

export default ProfileSettingsPage;

function SentryTestButtons() {
  const sendHandled = () => {
    try {
      // Wymuszenie błędu
      throw new Error(`Sentry test (handled) ${new Date().toISOString()}`);
    } catch (err) {
      // Logowanie do Sentry bez wysadzania UI
      Sentry.withScope((scope) => {
        Sentry.captureException(err);
      });
      alert("Wysłano błąd (handled) do Sentry. Sprawdź zakładkę Issues.");
    }
  };

  const sendUnhandled = () => {
    // RZUĆ prawdziwy wyjątek — trafi jako Unhandled
    // (Jeśli otoczysz komponent Error Boundary, UI nie zniknie na stałe)
    throw new Error(`Sentry test (UNHANDLED) ${new Date().toISOString()}`);
  };

  return (
    <div style={{ display: "grid", gap: 8 }}>
      <button onClick={sendHandled}>Wyślij błąd (handled)</button>
      <button onClick={sendUnhandled}>Wywołaj błąd (unhandled)</button>
    </div>
  );
}
